<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0">
        <v-layout justify-center>
            <v-flex md10 pa-10>
                <div class="app_border layout__overflow-hidden">
                    <h1 class="text--teal">Manage your templates</h1>

                    <v-sheet class="mx-auto">
                        <v-slide-group v-model="model" class="pa-4 edit-template-group" show-arrows center-active>
                            <v-slide-item v-for="n in apiTemplates.length" :key="n">
                                <v-card class="ma-4" width="300">
                                    <v-img 
                                        height="200" 
                                        class="align-end" 
                                        :src="apiTemplates[n - 1].previewImageFront" 
                                        :lazy-src="tileLoadingImage" 
                                        contain 
                                        v-on:error="onImageError(apiTemplates[n - 1])"
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                                class="fill-height ma-0"
                                                align="center"
                                                justify="center"
                                            >
                                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                    <div class="pa-2">
                                        <v-card-title class="py-1 my-0">{{apiTemplates[n - 1].title}}</v-card-title>
                                        <v-card-subtitle class="py-1 my-0">{{apiTemplates[n - 1].folder}}</v-card-subtitle>
                                        <v-card-subtitle class="py-1 my-0">{{apiTemplates[n - 1].dimensions}}</v-card-subtitle>
                                        <v-card-subtitle class="py-1 my-0">{{apiTemplates[n - 1].orientation}}</v-card-subtitle>
                                        <v-card-subtitle class="py-1 my-0 text__style-bold">{{apiTemplates[n - 1].customerRef}}</v-card-subtitle>
                                    </div>
                                    <v-card-actions class="template-item">
                                        <v-row align="center" justify="center" class="py-2 layout__margin-0">
                                            <v-row align="center" justify="center" class="py-0">
                                                <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer"
                                                        @click="editTemplate(apiTemplates[n - 1])">Edit Template
                                                </el-button>
                                            </v-row>

                                            <v-row align="center" justify="center" class="py-0">
                                                <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-right"
                                                        :disabled="!apiTemplates[n - 1].preview"
                                                        @click="previewTemplate(apiTemplates[n - 1], 'Front')">Preview Front
                                                </el-button>
                                            </v-row>

                                            <v-row align="center" justify="center" class="py-0">
                                                <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-right"
                                                        :disabled="!apiTemplates[n - 1].preview"
                                                        @click="previewTemplate(apiTemplates[n - 1], 'Back')">Preview Back
                                                </el-button>
                                            </v-row>

                                            <v-switch 
                                                @click="hideTemplate(apiTemplates[n - 1])" 
                                                v-model="apiTemplates[n - 1].hide"
                                                class="pa-2" 
                                                label="Hide Template"
                                            ></v-switch>

                                            <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer"
                                                    @click="showDeleteTemplateDialog(apiTemplates[n - 1])">Delete Template
                                            </el-button>
                                        </v-row>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-item>
                        </v-slide-group>
                    </v-sheet>

                    <div class="margin-top-10px"></div>

                    <v-row>
                        <v-col>
                            <v-radio-group v-model="templates" row @change="getTemplates()">
                                <v-radio
                                    label="Show generic templates"
                                ></v-radio>
                                <v-radio
                                    label="Show user-specific templates"
                                ></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col>
                            <v-checkbox
                                v-model="showHiddenTemplates"
                                label="Show hidden templates"
                                @change="getTemplates()"
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                            @click="createTemplate()">Create New Design
                    </el-button>

                    <div class="layout__padding-clear" v-show="deleteTemplateDialog">
                        <el-dialog
                                :visible.sync="deleteTemplateDialog"
                                :close-on-press-escape="false"
                                :close-on-click-modal="false"
                                custom-class="delete-template-dialog"
                                width="550px">
                            <div class="text__size-22 text__align-center text__colour-teal layout__margin__bottom-20 text__style-bold">Are you sure you want to delete this template?</div>
                            <div class="text__size-16 text__align-center layout__margin__top-20 layout__margin__bottom-20 text__line-height-12">
                                <v-checkbox v-model="deleteStateFile"
                                            :disabled="loading"
                                            class="float-left px-2"
                                            label="Do you want to delete the template (state file) from the server?"
                                            required>
                                </v-checkbox>
                            </div>

                            <div class="text__align-center layout__margin__top-50 layout__margin__left-50 layout__margin__right-50">
                                <el-button class="button__base layout__width-150px button-teal layout__cursor-pointer layout__float-left"
                                        v-on:click="deleteTemplateDialog = false" :disabled="loading">Cancel
                                </el-button>
                                <el-button class="button__background-red button__base layout__width-150px layout__cursor-pointer layout__float-right"
                                        v-on:click="deleteTemplate()" :disabled="loading">Delete Template
                                </el-button>
                            </div>
                        </el-dialog>
                    </div>

                    <v-dialog v-model="imagePreviewDialog"
                            content-class="display--white"
                            persistent max-width="800px">
                        <v-img 
                            height="800"
                            class="align-end"
                            :src="imagePreviewUrl"
                            :lazy-src="tileLoadingImage"
                            contain 
                        >
                            <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>

                        <v-row align="center" justify="center" class="py-2">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-right"
                                    v-on:click="imagePreviewDialog = false">Close
                            </el-button>
                        </v-row>
                    </v-dialog>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </div>
            </v-flex>

            <v-snackbar v-model="retrieveTemplatesFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem retrieving template information. Please try again.
                <v-btn dark text @click="retrieveTemplatesFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

            <v-snackbar v-model="saveTemplateFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem amending your template. Please try again.
                <v-btn dark text @click="saveTemplateFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

            <v-snackbar v-model="deleteTemplateSuccess" color="success" :top="true" :timeout="5000">
                Template deleted successfully.
                <v-btn dark text @click="deleteTemplateSuccess = false">
                    Close
                </v-btn>
            </v-snackbar>

            <v-snackbar v-model="deleteTemplateFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem deleting this template. Please try again.
                <v-btn dark text @click="deleteTemplateFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        data() {
            return {
                apiTemplates: [],
                apiTemplate: {},
                templates: 0,
                model: null,
                files: null,
                loading: false,
                tileLoadingImage: '',
                deleteTemplateDialog: false,
                deleteStateFile: false,
                imagePreviewDialog: false,
                imagePreviewUrl: '',
                showHiddenTemplates: false,
                retrieveTemplatesFailure: false,
                saveTemplateFailure: false,
                deleteTemplateSuccess: false,
                deleteTemplateFailure: false,
                customersCanvasApiKey: `${process.env.VUE_APP_CUSTOMERS_CANVAS_API_KEY}`,
			}
        },
        components: {
        },
        mixins: [axios],
        computed: {
        },
        created() {
            window.dispatchEvent(new CustomEvent('version-changed', {
                detail: {
                    storage: 'manage-templates'
                }
            }));

            this.getTemplates();
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            getTemplates() {
                // const getTemplates = this.accountsApiHostUrl + '/api/services/app/Artwork/FindArtworkTemplates';
                const getTemplates = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/FindArtworkTemplates`;
                console.log(getTemplates);

                this.apiTemplates = [];
                this.loading = true;

                this.tileLoadingImage = 'https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/Ravensworth_Image_Tile.png';

                Axios.get(getTemplates)
                    .then(response => {
                        response.data.result.forEach(template => {
                            if ((this.templates == 0 && template.isGeneric || this.templates == 1) && (this.showHiddenTemplates || (!this.showHiddenTemplates && template.isActive))) {
                                var dimensions = template.pageHeight + 'mm (h) x ' + template.pageWidth + 'mm (w)',
                                    orientation = (template.pageHeight > template.pageWidth) ? "Portrait" : (template.pageHeight < template.pageWidth ? "Landscape" : "Square"),
                                    customerRef = '';

                                if (template.customerRef !== undefined && template.customerRef !== null) {
                                    customerRef = 'Branch: ' + template.customerRef;
                                }

                                this.apiTemplates.push({
                                    id: template.id,
                                    title: template.name,
                                    name: template.name,
                                    url: template.masterUrl,
                                    thumb: template.thumbUrl.substr(0, template.thumbUrl.indexOf('||')),
                                    thumbUrl: template.thumbUrl,
                                    previewImageFront: template.thumbUrl.split('||')[0],
                                    previewImageBack: template.thumbUrl.split('||')[1],
                                    fCode: template.fCode,
                                    folder: template.folder,
                                    dimensions: dimensions,
                                    orientation: orientation,
                                    generic: template.isGeneric,
                                    hide: !template.isActive,
                                    pages: template.pageCount,
                                    width: template.pageWidth,
                                    height: template.pageHeight,
                                    testDataJson: template.testDataJson,
                                    customerRef: customerRef,
                                    userId: template.userId,
                                    preview: true,
                                })
                            }
                        })

                        this.apiTemplates.sort((a, b) => {
                            if (a.name < b.name)
                                return -1;
                            if (a.name > b.name)
                                return 1;
                            return 0;
                        });

                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);

                        this.retrieveTemplatesFailure = true;
                        this.loading = false;
                    })
            },
            createTemplate() {
                console.log('create template');

                window.sessionStorage.removeItem('editTemplate');
                this.navigate('edit-template');
            },
            editTemplate(template) {
                console.log('edit template');
                console.log(template);

                window.sessionStorage.setItem('editTemplate', JSON.stringify(template));
                this.navigate('edit-template');
            },
            previewTemplate(template, side) {
                console.log('previewTemplate');

                var previewImage;

                if (side == 'Front') {
                    console.log(template.previewImageFront);
                    previewImage = template.previewImageFront.replace(/=300/g, '=800');
                }

                if (side == 'Back') {
                    console.log(template.previewImageBack);
                    previewImage = template.previewImageBack.replace(/=300/g, '=800');
                }

                console.log('previewImage=' + previewImage);

                this.imagePreviewUrl = previewImage;
                this.imagePreviewDialog = true;
            },
            async hideTemplate(template) {
                console.log('hide/unhide template');
                console.log(template);
                console.log(!!template.hide);

                const url = `${process.env.VUE_APP_EXTERNAL_ACCOUNTS}/api/services/app/Artwork/DeleteArtworkTemplate?id=${template.id}&fromserver=0}`;

                try {
                    await Axios.delete(url, this.returnHeaderUsingToken());

                    var endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/AddArtworkTemplate`,
                        templateDetails;

                    templateDetails = {
                        "id": template.id,
                        "name": template.name,
                        "masterUrl": template.url,
                        // "customerRef": null,
                        "customerRef": template.customerRef.replace('Branch: ', ''),
                        "fCode": template.fCode,
                        // "thumbUrl": template.previewImageFront + '||' + template.previewImageBack,
                        "ThumbUrl": template.thumbUrl,
                        "saved": this.getNow(),
                        "isActive": !template.hide,
                        "folder": template.folder,
                        "isGeneric": template.generic,
                        "pageCount": template.pages,
                        "pageHeight": template.height,
                        "pageWidth": template.width,
                        "TestDataJson": template.testDataJson,
                        // "userId": null
                        "userId": template.userId
                    }

                    console.log('templateDetails: ' + JSON.stringify(templateDetails));

                    Axios.post(endpoint, templateDetails, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log(response);

                            this.getTemplates();
                        })
                        .catch(error => {
                            console.log(error);

                            this.saveTemplateFailure = true;
                        })
                } catch {
                    console.log('DeleteArtworkTemplate failed');

                    this.saveTemplateFailure = true;
                }
            },
            showDeleteTemplateDialog(template) {
                this.apiTemplate = template;
                this.deleteStateFile = false;
                this.deleteTemplateDialog = true;
            },

            async deleteTemplate() {
              if (this.loading) {
                return;
              }

              this.loading = true;

              const url = `${process.env.VUE_APP_EXTERNAL_ACCOUNTS}/api/services/app/Artwork/DeleteArtworkTemplate?id=${this.apiTemplate.id}&fromserver=0}`;

              try {
                await Axios.delete(url, this.returnHeaderUsingToken());

                this.deleteTemplateDialog = false;
                this.deleteTemplateSuccess = true;
                this.getTemplates();

                this.loading = false;
              } catch {
                this.deleteTemplateDialog = false;
                this.deleteTemplateFailure = true;
                this.loading = false;
              }
            },

            onImageError(template) {
                template.previewImageFront='https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/No_Image.png';
                template.preview = false;
            },
            getNow: function() {
                const today = new Date();
                const date = today.getFullYear() + '-' + this.pad2(today.getMonth() + 1) + '-' + this.pad2(today.getDate());
                const time = this.pad2(today.getHours()) + ":" + this.pad2(today.getMinutes()) + ":" + this.pad2(today.getSeconds()) + "." + this.pad3(today.getMilliseconds());
                const dateTime = date + 'T' + time + 'Z';
                
                return dateTime;
            },
            pad2: function (value) {
                return ('00' + value).slice(-2);
            },
            pad3: function (value) {
                return ('000' + value).slice(-3);
            },
            getFileExtension(filename) {
                return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
            }
		}
    };
</script>